/**
 * Transaction Status config
 *
 * Below config values must be same as the values in the database
 *
 */

export const transactionStatuses = {
  created: 'created',
  pending: 'REVIEWPENDING',
  processing: 'processing',
  completed: 'completed',
  rejected: 'rejected',
  paid: 'paid',
};

/**
 *
 * Transaction Status options setup is for html select
 */

export const transactionStatusOptions = [
  { value: transactionStatuses.pending, label: 'Review Pending' },
  { value: transactionStatuses.created, label: 'Created' },
  { value: transactionStatuses.processing, label: 'Processing' },
  { value: transactionStatuses.completed, label: 'Completed' },
  { value: transactionStatuses.rejected, label: 'Rejected' },
  { value: transactionStatuses.paid, label: 'Paid' },
];
